import { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import FormHelperText from '@mui/material/FormHelperText'
import { useUpdateRecognitionMutation } from '@/api/enterance'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearPlateNumberEditParams,
  selectPlateNumberEditParams,
  selectShowPlateNumberEdit
} from './modalsSlice'
import { useTranslation } from 'react-i18next'

const PlateNumberEditModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const show = useSelector(selectShowPlateNumberEdit)
  const modalParams = useSelector(selectPlateNumberEditParams)
  const [numberInputValue, setNumberInputValue] = useState('')
  const [updateRecognition, { isLoading, isError, reset }] = useUpdateRecognitionMutation()

  useEffect(() => {
    if (show) {
      setNumberInputValue(modalParams?.plateNumber || '')
    }
  }, [show, modalParams])

  const handleClose = () => {
    setNumberInputValue('')
    dispatch(clearPlateNumberEditParams())
    reset()
  }

  const handleSubmit = async (event) => {
    event?.stopPropagation?.()
    event?.preventDefault?.()
    try {
      await updateRecognition({
        id: modalParams?.entryId,
        plate_number: numberInputValue
      }).unwrap()
      // defer close so nested Dialog click doesn't hit parent backdrop
      queueMicrotask(handleClose)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="History Info Dialog"
      aria-describedby="History Info Dialog"
    >
      <DialogTitle id="scroll-dialog-title">{t('editing')}</DialogTitle>
      <DialogContent dividers>
        <FormControl
          fullWidth
          sx={{ mb: 3, mt: 1 }}
          error={isError}
        >
          <InputLabel>{t('number')}</InputLabel>
          <OutlinedInput
            name="number"
            value={numberInputValue}
            onChange={({ target }) => setNumberInputValue(target.value)}
            label={t('number')}
          />
          {isError && (
            <FormHelperText error>
              {t('error_occurred_try_again_later')}
            </FormHelperText>
          )}
        </FormControl>
        <Button
          loading={isLoading}
          sx={{ mt: 3 }}
          fullWidth
          variant="contained"
          disabled={!numberInputValue}
          onClick={handleSubmit}
        >
          {t('save')}
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default PlateNumberEditModal
